export const PAGE_LIMIT = 30;
export const PAGE_LIMIT_TEN = 10;
export const PAGE_LIMIT_TWENTY = 20;
export const PAGE_LIMIT_FIVE = 5;
export const PAGE_LIMIT_FIFTY = 50;
export const PAGE_LIMIT_NINE = 9;
export const PAGE_LIMIT_HUNDRED = 100;
export const PAGE_INDEX = 0;
export const STORE_VERSION =
  (import.meta.env.VITE_APP_VERSION as number) ?? 1.0;
export const CHART_COLOR_MAP: Record<string, string> = {
  positive: "hsl(var(--green))",
  negative: "hsl(var(--destructive))",
  neutral: "hsl(var(--amber))",
  accent: "hsl(var(--accent))",
  default: "#9ca3af",
};
